/* eslint-disable max-len */
import { DialogType } from 'commons/Dialog/DialogTypes';
import { localize } from 'commons/LocalizedText/LocalizedText';
import { UserAdministrationCookies } from 'components/Account/UserAdministrationCookies';
import { LaboUserEdit } from 'components/LaboAdmin/LaboUserEdit';
import { useDialog } from 'hook/DialogProvider';
import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import { UserService } from 'services/UserService';
import { ErrorName } from 'utils/constants/error.name';
import { ROUTES } from 'utils/constants/routes';

export const AccountRoutes = ({ general }) => {
  const { laboratory } = useParams();
  const showDialog = useDialog();
  const [account, setAccount] = useState();

  useEffect(() => {
    if (general) {
      return;
    }
    UserService.getDetailsFromAccount(laboratory).then((resp) => {
      setAccount(resp.personContactDetailsRecid);
    })
      .catch((errorMessage) => {
        if (errorMessage !== ErrorName.ABORT_ERROR) {
          showDialog({
            variant: DialogType.ERROR,
            title: localize('error'),
            description: errorMessage
          });
        }
      })
  }, [general, laboratory, showDialog]);

  const baseURL = general ? ROUTES.GENERAL_ACCOUNT : ROUTES.ACCOUNT;

  return (
    <div style={{marginTop: '50px'}}>
      <Switch>
        <Route component={() => <LaboUserEdit laboratoryId={laboratory} personContactDetailsId={account}/>} path={baseURL.PROFILE} />
        <Route component={UserAdministrationCookies} path={baseURL.COOKIES} />
        <Redirect from={baseURL.BASE} to={baseURL.PROFILE} />
      </Switch>
    </div>
  );
};